/**
 * Error logging
 *
 * @param  {Error} error - caught exception
 * @return {Error} - trown error
 */
export default function logError(error) {
  console.error('fetch encountered error:', error); // eslint-disable-line no-console

  throw error;
}